module.exports = __webpack_public_path__ + "static/media/covid_qr_indicate_1-1.b29332af.gif";